import { EmptyLayoutPage } from '../../app/settings/emptypages//emptylayout/empty-layout.page';
import { EmptyDataPage } from '../../app/settings/emptypages/emptydata/empty-data.page';
import { EmptyUserPage } from '../../app/settings/emptypages/emptyuser/empty-user.page';
import { AppMonitoringPage } from '../components/pages/app-monitoring.page';
import { ContentPage } from '../components/pages/content.page';
import { DashboardPage } from '../components/pages/dashboard.page';
import { IntegrationPage } from '../components/pages/integration.page';
import { NotFound404Page } from '../components/pages/not-found404.page';
import { PermissionDeniedPage } from '../components/pages/not-permitted.page';
import { SettingsPage } from '../components/pages/settings.page';
import { WorkflowMonitoringPage } from '../components/pages/workflow-monitoring.page';
import { AEmptyBasePage } from '../settings/emptypages/empty.base.page';
import { EmptyAboutPage } from '../settings/emptypages/emptyabout/empty-about.page';
import { EmptyCiPage } from '../settings/emptypages/emptyci/empty-ci.page';
import { EmptySettingsPage } from '../settings/emptypages/emptysettings/empty-settings.page';

export const APP_PAGES = [
    NotFound404Page,
    ContentPage,
    SettingsPage,
    PermissionDeniedPage,
    IntegrationPage,
    DashboardPage,
    AppMonitoringPage,
    WorkflowMonitoringPage,
    EmptyLayoutPage,
    EmptyDataPage,
    EmptyUserPage,
    EmptyCiPage,
    EmptySettingsPage,
    EmptyAboutPage
];
